import React, { Component } from "react";
import launchIcon from "../images/LaunchIcon.svg";
import { s360ConfigService } from "./Services/S360Config";

class StartUp extends Component {
  render() {
    const ifFullScreen = localStorage.getItem("openInFullScreen");
    console.log(this.ifFullScreen, "here");

    let tooltipMessage =
      s360ConfigService.config.configDetails &&
      s360ConfigService.config.configDetails.introductionMessage;
      
    return (
      <div
        className={
          ifFullScreen
            ? "s360-startup-float-container-fs"
            : "s360-startup-float-container"
        }
        id="test-container"
      >
        {/* <img height={103} width={103} src={launchIcon} alt="" /> */}
        {/* <div className="s360-startup-float-message-contianer" style={{visibility: tooltipMessage ? "visible" : "hidden" }}><span class="s360-startup-float-message">s360ConfigService.config.designDetails.introductionMessage</span></div> */}
        {/* {this.startUpIconSVG()} */}

        <div
          className="s360-startup-float-container-lauchIcon"
          onClick={() => {
            this.props.actions.onStartUpClick();
          }}
          style={{
            borderRadius:
              s360ConfigService.config.configDetails?.iconRadius
                .toString()
                .includes("px") ||
              s360ConfigService.config.configDetails?.iconRadius
                .toString()
                .includes("%")
                ? s360ConfigService.config.configDetails?.iconRadius
                : "50%",
            border:
              s360ConfigService.config.configDetails?.headerMessage ===
              "OOREDOO"
                ? "none"
                : "16px solid white",
            // boxShadow:s360ConfigService.config.configDetails?.headerMessage === "OOREDOO" ? "none" : "0px 12px 24px #00000029",
            width: s360ConfigService.config.configDetails?.iconWidth
              .toString()
              .includes("px")
              ? s360ConfigService.config.configDetails.iconWidth
              : "65px",
            height: s360ConfigService.config.configDetails?.iconHeight
              .toString()
              .includes("px")
              ? s360ConfigService.config.configDetails.iconHeight
              : "65px",
          }}
        >
          <img /*height={s360ConfigService.config.designDetails.launchIconHeight} width={s360ConfigService.config.designDetails.launchIconWidth} */
            /* height="28px" width="28px"*/ style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "100%",
              height: "100%",
            }}
            src={s360ConfigService?.config?.designDetails?.launchIcon}
            alt=""
          />{" "}
        </div>
      </div>
    );
  }

  startUpIconSVG = () => {
    let aStyle = {
      fill: s360ConfigService.config.designDetails.headerColor || "#d9322e",
    };
    let bStyle = { opacity: "0.301" };
    let cStyle = { fill: "#fff" };
    let dStyle = { fill: "none", strokeLinecap: "round" };
    let eStyle = { stroke: "#000" };
    let fStyle = { filter: "url(#a)" };

    return (
      <svg
        onClick={() => {
          this.props.actions.onStartUpClick();
        }}
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
        width="90"
        height="90"
        viewBox="0 0 120 120"
      >
        <defs>
          {/* <style>.a{fill:#d9322e;}.b{opacity:0.301;}.c{fill:#fff;}.d{fill:none;stroke-linecap:round;}.d,.e{stroke:#000;}.f{filter:url(#a);}</style> */}
          <filter
            id="a"
            style={aStyle}
            x="0"
            y="0"
            width="121"
            height="121"
            filterUnits="userSpaceOnUse"
          >
            <feOffset dy="3" input="SourceAlpha" />
            <feGaussianBlur stdDeviation="3" result="b" style={bStyle} />
            <feFlood floodColor="#4a0404" floodOpacity="0.376" />
            <feComposite operator="in" in2="b" style={bStyle} />
            <feComposite in="SourceGraphic" />
          </filter>
        </defs>
        <g transform="translate(-1608 -869)">
          <g class="f" transform="matrix(1, 0, 0, 1, 1608, 869)" style={fStyle}>
            <circle
              class="a"
              style={aStyle}
              cx="51.5"
              cy="51.5"
              r="51.5"
              transform="translate(9 6)"
            />
          </g>
          <path
            class="b"
            style={bStyle}
            d="M10,56.885a10,10,0,0,1-10-10V25.8a10,10,0,0,1,10-10H46.649L55.5,3V16.737A10,10,0,0,1,61.267,25.8V46.884a10,10,0,0,1-10,10Z"
            transform="translate(1695.025 964.572) rotate(180)"
          />
          <path
            class="c"
            style={cStyle}
            d="M10,56.885a10,10,0,0,1-10-10V25.8a10,10,0,0,1,10-10H46.649L55.5,3V16.737A10,10,0,0,1,61.267,25.8V46.884a10,10,0,0,1-10,10Z"
            transform="translate(1700.792 958.085) rotate(180)"
          />
          <ellipse
            cx="5.5"
            cy="6"
            rx="5.5"
            ry="6"
            transform="translate(1653 912)"
          />
          <ellipse
            cx="5.5"
            cy="6"
            rx="5.5"
            ry="6"
            transform="translate(1677 912)"
          />
          <g transform="translate(1664.266 930.392)">
            <path
              class="d"
              style={dStyle}
              d="M1736,3426.5s3.309,2.2,6.413,2.2a11.1,11.1,0,0,0,5.581-1.906c.2-.123.422-.292.422-.292"
              transform="translate(-1736 -3426.5)"
            />
            <path
              class="e"
              style={eStyle}
              d="M1736.441,3426.735a25.786,25.786,0,0,0,5.936,1.055,26.912,26.912,0,0,0,6.007-1.055c-.077.025-1.6.928-2.5,1.324a7.686,7.686,0,0,1-3.075.659,10.949,10.949,0,0,1-3.781-.659A8.2,8.2,0,0,1,1736.441,3426.735Z"
              transform="translate(-1736.123 -3426.566)"
            />
          </g>
        </g>
      </svg>
    );
  };
}

export default StartUp;
